<template lang="html">
  <v-list-item
    :class="{
      'v-list-item--unset-height': generatedByForm,
      'px-sm-2': !disablePadding,
      'px-sm-4 pl-sm-2': !reducePadding && !disablePadding
    }"
    class="px-0"
    :two-line="numberOfLines >= 2"
  >
    <v-list-item-avatar
      v-if="object && !disableAvatar"
      :size="avatarSizeCustom || avatarSizeDefault"
      color="avatarBackground"
      class="mr-2 my-0"
      :class="{ 'my-0': fromIndexList, 'increased-content-top-margin': fromIndexList && numberOfLines == 1 }"
    >
      <AvatarContent
        :fromIndexList="fromIndexList"
        :object="object"
        :object-key-for-initials="avatarText"
        :text="title || subtitle || additionalSubtitle"
        :small-initials="(avatarSizeCustom || avatarSizeDefault) < 30"
      />
    </v-list-item-avatar>

    <v-list-item-content
      :class="{
        'pt-2': !fromIndexList && !generatedByForm,
        'py-0': fromIndexList || generatedByForm,
        'increased-content-top-margin': fromIndexList && numberOfLines == 1,
        'three-line-spacing': numberOfLines === 3
      }"
    >
      <template v-if="title || hasSlot('title')">
        <v-list-item-title
          :class="{
                  'txt-title-for-show-form-element': generatedByForm,
                  'txt-title': !generatedByForm,
                  'avatar-title-color-for-index': mode == 'index',
                  'font-weight-regular': noBold,
                  'text-truncate': normalTruncate,
                  ...computeCustomTextTruncateClasses
          }"
          :style="{fontSize: `${fontSize}px`}"
          class="mb-0"
        >
          <slot v-if="hasSlot('title')" name="title" />
          <template v-else>
            {{ title }}
          </template>
          
        </v-list-item-title>
      </template>

      <template v-if="(showAllLines || !generatedByForm) && (subtitle || hasSlot('subtitle'))">
        <v-list-item-subtitle class="custom-text-truncate">
          <slot v-if="hasSlot('subtitle')" name="subtitle" />
          <template v-else>
            {{ subtitle }}
          </template>
          
        </v-list-item-subtitle>
      </template>

      <template v-if="(showAllLines || !generatedByForm) && (additionalSubtitle || hasSlot('additionalSubtitle'))">
        <v-list-item-subtitle
          :class="{'increased-content-top-margin': numberOfLines != 1 }"
          class="custom-text-truncate word-break-break-word"
        >
          <slot v-if="hasSlot('additionalSubtitle')" name="additionalSubtitle" />
          <template v-else>
            {{ additionalSubtitle }}
          </template>
        </v-list-item-subtitle>
      </template>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
import { capitalize } from 'lodash';
import AvatarContent from '@/components/AvatarContent.vue';

export default {
  components: {
    AvatarContent,
  },
  props: {
    disableAvatar: {
      type: Boolean,
      default: undefined,
    },
    object: {
      type: Object,
      default: undefined,
    },
    avatarText: {
      type: String,
      default: undefined,
    },
    title: {
      type: String,
      default: undefined,
    },
    subtitle: {
      type: String,
      default: undefined,
    },
    additionalSubtitle: {
      type: String,
      default: undefined,
    },
    truncateLines: {
      type: String,
      default: '1',
    },
    //for if we want to use vuetify text-truncate class
    normalTruncate: {
      type: Boolean,
      default: false,
    },
    truncateOnBreakWord: {
      type: Boolean,
      default: false,
    },
    reducePadding: {
      type: Boolean,
      default: false,
    },
    disablePadding: {
      type: Boolean,
      default: false,
    },
    fromIndexList: {
      type: Boolean,
      default: false,
    },
    noBold: {
      type:Boolean,
      default: false,
    },
    inline: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      default: undefined,
    },
    fontSize: {
      type: String,
      default: '16',
    },
    //Avatar Size
    small: {
      type: Boolean,
      default: false,
    },
    xSmall: {
      type: Boolean,
      default: false,
    },
    avatarSize: {
      type: [String, Number],
      default: undefined,
    },
    //when avatarComplex is auto generated by form element, per design, by default only show one (title) line
    generatedByForm: {
      type: Boolean,
      default: false,
    },
    defaultTextStyling: {
      type: Boolean,
      default: true,
    },
    //Shows all available (sub/additional subtitle) lines
    //overrided default generatedByForm logic that only shows one line
    showAllLines: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    computeCustomTextTruncateClasses() {
      let classes = {};

      if (this.truncateLines == '1' && !this.normalTruncate) {
        classes[`custom-text-truncate${this.truncateOnBreakWord ? ' word-break-break-word' : ''}`] = true;
      }

      if (this.truncateLines == '2' && !this.normalTruncate) {
        classes[`custom-text-truncate-2${this.truncateOnBreakWord ? ' word-break-break-word' : ''}`] = true;
      }

      return classes;
    },
    numberOfLines() {
      var num = 0;
      if (this.title || this.hasSlot('title'))
        num += 1;

      if (!this.generatedByForm) {
        if (this.subtitle || this.hasSlot('subtitle'))
          num += 1;
        if (this.additionalSubtitle || this.hasSlot('additionalSubtitle'))
          num += 1;
      }

      return num;
    },
    avatarSizeCustom() {
      if (this.avatarSize)
        return parseInt(this.avatarSize, 10); //if undefined, it returns 0

      if (this.small)
        return 32;

      if (this.xSmall)
        return 26;

      if (this.generatedByForm)
        return 32;
 
      return undefined;
    },
    avatarSizeDefault() {
      if (this.inline && this.numberOfLines <= 1) {
        return 26;
      } else if (this.fromIndexList) {
        switch (this.$vuetify.breakpoint.name) {
          case 'xs':
            return 42;
          case 'sm':
            return 47;
          case 'md':
          case 'lg':
          case 'xl':
            return 45;
          default:
            return 45;
        }
      } else {
        switch (this.$vuetify.breakpoint.name) {
          case 'xs':
            return 32;
          case 'sm':
          case 'md':
          case 'lg':
          case 'xl':
            return 40;
          default:
            return 40;
        }
      }
    }
  },
  methods: {
    capitalize,
    hasSlot(slotName) {
      return Object.prototype.hasOwnProperty.call(this.$scopedSlots, slotName);
    },
  },
};
</script>
<style lang="css" scoped>
.txt-title{
  font-weight: 600;
}
/*.increased-content-top-margin {
  margin-top: 2px;
}*/
.avatar-title-color-for-index {
  color: var(--v-avatarTitleForIndex-base) !important;
}
</style>
<style lang="scss" scoped>
.txt-title-for-show-form-element {
  @include text-value
}
.v-list-item--unset-height {
  min-height: unset !important;
}
.three-line-spacing > :not(:last-child) {
	margin-bottom: 0px !important;
	margin-top: -1px !important;
}
.v-list-item__title {
	margin-bottom: 0px !important;
}
</style>
